/**
 * FAQ accordion fallback.
 *
 * Chrome and Safari implement the exclusive accordion natively via
 * `<details name="...">`, so nothing is needed there. This only covers
 * browsers that ignore the attribute, and it exits immediately where support
 * exists so no listener is attached for nothing.
 */
(function () {
  'use strict';

  // Feature-detect: a browser that supports the attribute exposes the property.
  const nativeExclusive = 'name' in document.createElement('details');
  if (nativeExclusive) return;

  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.open) return;

    const group = item.closest('[data-single-open="true"]');
    if (!group) return;

    group.querySelectorAll('details[open]').forEach((other) => {
      if (other !== item) other.open = false;
    });
  }, true);
})();
